<template>
    <div>
        <Table :loading="loading"   :columns="columns" :data="data"></Table>
        <Page :total="total" :current="current" :page-size="size" @on-change="changePage" show-elevator show-total class-name="page-class"  />
    </div>
</template>

<script>
    export default {
        name: "PageTable",
        props:{
            contents:{
              type:String
            },
            total:{
                type:Number,
                default:0
            },
            loading:{
                type:Boolean,
                default:false
            },
            current:{
                type:Number,
                default:1
            },
            size:{
                type:Number,
                default:30
            },
            columns:{
                type:Array,
                default:function(){
                    return [];
                }
            },
            data:{
                type:Array,
                default:function(){
                    return [];
                }
            }
        },
        methods:{
            changePage(index){
                this.$emit('switchPage', index)
            }
        }
    }
</script>

<style scoped>
.page-class{
    margin-top:10px;text-align: right
}
</style>
